import parseTagContent from '@anm/helpers/parsers/parseTagContent';

export const getImageAlt = (title = '', description = '') =>
  parseTagContent(title).join('') || parseTagContent(description).join('');
